import * as React from "react";
import {BrowserRouter, Switch, Route, Redirect} from 'react-router-dom';

import AbonentLogs from "../Admin/AbonentLogs/AbonentLogs";
import ServiceLogs from "../Admin/ServiceLogs";
import Services from "../Admin/Services/Services";
import KPLogs from "../Admin/KPLogs/KPLogs";
import KP from "../Admin/KP/KP";
import ServicesEdit from "../Admin/ServicesEdit/ServicesEdit";
import Buy from "../Buy/Buy";
import BuyInfo from "../Buy/BuyInfo";
import {default as KPAdd} from "../Admin/KP/Add";
import {default as KPEdit} from "../Admin/KP/Edit";
import KPLogsParams from "../Admin/KPLogs/Params";
import {default as ServiceAdd} from "../Admin/ServicesEdit/Add";
import {default as ServiceEdit} from "../Admin/ServicesEdit/Edit";
import ServiceLogsParams from "../Admin/ServiceLogs/Params";
import AbonentLogsParams from "../Admin/AbonentLogs/Params";
import Details from "../Admin/Services/Details/Details";
import Auth from "../Auth";
import Exit from "../Auth/Exit";
import Main from "../Main";

const routes = [
    [ "/admin/services", Services, "Услуги" ],
    [ "/admin/services/:service", Details, "Подробнее об услуге" ],
    [ "/admin/abonent_logs", AbonentLogs, "Логи абонентов" ],
    [ "/admin/abonent_logs/:params", AbonentLogsParams, "Логи абонентов" ],
    [ "/admin/service_logs", ServiceLogs, "Логи сервисов" ],
    [ "/admin/service_logs/:params", ServiceLogsParams, "Логи сервисов" ],
    [ "/admin/kp_logs", KPLogs, "Логи КП" ],
    [ "/admin/kp_logs/:params", KPLogsParams, "Логи КП" ],
    [ "/admin/services_edit", ServicesEdit, "Редактирование услуг" ],
    [ "/admin/services_edit/add", ServiceAdd, "Редактирование услуг" ],
    [ "/admin/services_edit/edit/:login", ServiceEdit, "Редактирование услуг" ],
    [ "/admin/kp", KP, "КП" ],
    [ "/admin/kp/add", KPAdd, "Добавление КП" ],
    [ "/admin/kp/edit/:id", KPEdit, "Редактирование КП" ],
    [ "/auth", Auth, 'Авторизация' ],
    [ "/auth/exit", Exit, 'Выход' ],
    [ "/:service/info/:source/:lang", BuyInfo, "Информация об услуге" ],
    [ "/:service/info/:lang", BuyInfo, "Информация об услуге" ],
    [ "/:service/info", BuyInfo, "Информация об услуге" ],
    [ "/:service/:source/:lang/:urlCode", Buy, "Покупка услуги" ],
    [ "/:service/:source/:lang", Buy, "Покупка услуги" ],
    [ "/:service/:source", Buy, "Покупка услуги" ],
    [ "/:service", Buy, "Покупка услуги" ],
    [ "/", Main, "Главная страница" ]
];

const SwitchRouter = (props) => {
    return (
        <Switch>
            <Redirect exact from='/admin' to="/admin/services"/>
            <Redirect exact from='/admin/services_edit/edit' to='/admin/services_edit' />
            { routes.map(v => <Route exact path={v[0]} component={v[1]} title={v[2]} key={v[0]} /> ) }
        </Switch>
    );
}

const Routes = (props) => {

    return (
        <BrowserRouter basename={process.env.REACT_APP_DEFAULT_PATH ?? ''}>
            <SwitchRouter/>
        </BrowserRouter>
    );
}

export default Routes;
